import { Component, OnInit } from '@angular/core';
import { OrderService, ProductService, AuthenticationService } from '@app/core';
import { Order } from '@core/model/order.model';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { Product } from '@app/core/model/product.model';
import { CurrencyPipe } from '@angular/common';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { ProformaService } from '@app/core/service/proforma.service';

@Component({
  selector: 'app-editproforma',
  templateUrl: './editproforma.component.html',
  styleUrls: ['./editproforma.component.css']
})
export class EditproformaComponent implements OnInit {

  orders: Order[];
  id: string;
  isLoading = false;
  orden: any;
  form: FormGroup;
  totalSum = 0;
  fecha_orden: string;
  fecha_entrega: string;
  currentUserSubscription: Subscription;

  currentUser: any;
  userid: string;

  value: boolean;
  myFormValueChanges$: any;
  products: Product[];

  nombre_cliente = '';
  nit = '';
  direccion = '';
  fecha_pedido = '';
  proforma_id = '';
  nombre_vendedor = '';
  estado = '';
  pago: '';

  monto: string;

  cancelacion = [
    {
      name: 'Contado',
      rnNo: 1
    },
    {
      name: 'Credito',
      rnNo: 2
    }
  ];
  selected: any;
  stock: string;
  cantPedidos: string;
  tipo_pago: string;
  constructor(
    private orderService: OrderService,
    private proformaService: ProformaService,
    private fb: FormBuilder,
    private productService: ProductService,
    private currencyPipe: CurrencyPipe,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthenticationService
  ) {
    this.currentUserSubscription = this.authService.currentUser.subscribe(
      user => {
        this.currentUser = user.data.user.id;
        //  console.log(this.currentUser.data.user);
        this.userid = this.currentUser;
      }
    );

    this.form = this.fb.group({
      credentials: this.fb.array([], Validators.required),
      pago: ''
    });
    this.myFormValueChanges$ = this.form.controls['credentials'].valueChanges;
    this.myFormValueChanges$.subscribe((units: any) =>
      this.updateTotalUnitPrice(units)
    );
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.id = params.id;

      this.listarOrden();
    });
    this.listProducts();

    console.log(this.selected);
  }

  nuevoProducto() {
    const numberPatern = '^[0-9.,]+$';
    const creds = this.form.controls.credentials as FormArray;
    creds.push(
      this.fb.group({
        producto_id: '',
        nombre_producto: '',
        producto: '',
        stock: '',
        cantidad: ['', [Validators.required, Validators.pattern('^[0-9]+(\.[0-9]+)?$')]],
        precio: ['', [Validators.required]],
        precio2: ['', [Validators.required]],
        costo: [{ value: '', disabled: true }],
        unidad: [{ value: '', disabled: true }],
        totalUnitPrice: [{ value: '', disabled: true }]
      })
    );
  }

  validarInput(event: any) {
    // Eliminar caracteres no permitidos
    event.target.value = event.target.value.replace(/[^0-9.]/g, '');

    // Si hay más de un punto, eliminar los adicionales
    if ((event.target.value.match(/\./g) || []).length > 1) {
      event.target.value = event.target.value.replace(/\.+$/, '');
    }
  }

  listProducts() {
    this.productService.getProductosExistencia().subscribe(
      data => {
        this.products = data;
        console.log(data);
      },
      error1 => {
        console.log(error1.error);
      }
    );
  }

  listarOrden() {
    this.isLoading = true;

    this.proformaService
      .getById(this.id)
      .pipe(
        finalize(() => {
          // this.userForm.markAsPristine();
          this.isLoading = false;
        })
      )
      .subscribe(
        data => {
          // console.log(credentials);
          // this.salas = data;

          this.orden = data;
          console.log(this.orden);
          this.nombre_cliente = this.orden.nombre_cliente ;
          this.nit = this.orden.nit;
          this.direccion = this.orden.direccion;
          this.fecha_entrega = this.orden.fecha_entrega;
          this.fecha_pedido = this.orden.fecha;
          this.proforma_id = this.orden.proforma_id;
          this.estado = this.orden.estado;
          this.tipo_pago = this.orden.tipo_pago;
          this.form.controls['pago'].setValue(this.tipo_pago, {
            onlySelf: true
          });
          //  this.form.value.pago.name = this.orden.tipo_pago;

          this.nombre_vendedor =
            this.orden.user.nombres + ' ' + this.orden.user.apellidos;

            console.log(this.orden.list);

          if (this.orden.list.length > 0) {
            const control = <FormArray>this.form.controls['credentials'];
            // for (let i = 1; i < this.orden.list.length + 1; i++) {
            //   control.push(
            //     this.fb.group({
            //       producto_id: '',
            //       stock: '',
            //       nombre_producto: '',
            //       cantidad: '',
            //       precio: '',
            //       costo: '',
            //       unidad: '',
            //       totalUnitPrice: ''
            //     })
            //   );
            // }
            // this.form.patchValue({ credentials: this.orden.list });
            // this.disableRows(control);
            this.orden.list.forEach((element:any,index:any) => {
                const control = <FormArray>this.form.controls['credentials'];
                  control.push(
                      this.fb.group({
                        producto_id: '',
                        stock: '',
                        nombre_producto: '',
                        cantidad: '',
                        precio: '',
                        costo: '',
                        unidad: '',
                        totalUnitPrice: ''
                      })
                    );
                  
                  control.controls[index].patchValue({
                    producto_id: element.producto_id,
                    stock: element.stock,
                    nombre_producto: element.codigo+'-'+element.nombre_producto,
                    cantidad: element.cantidad,
                    precio: element.precio,
                    costo: element.costo,
                    unidad: element.unidad,
                    totalUnitPrice: element.cantidad * element.precio
                  })
            });
          }
        },
        (error: any) => {
          console.log({ title: error.error, type: 'error' });
        }
      );
  }

  eliminarProducto(index: any) {
    const control = <FormArray>this.form.controls.credentials;
    control.removeAt(index);
  }
  getSelectedProduct(event: Product, i: number) {
    // alert(event);

    console.log('Producto Changed: ' + event.producto_id);
    // console.log(JSON.stringify(event));
    // this.resetPurchase();
    // this.showDiv = null;
    this.patchValues(event.producto_id, i);
    // this.addressCustomer = event.address;
  }

  patchValues(id: number, i: number) {
    const x = (<FormArray>this.form.controls['credentials']).at(i);
    //  this.stock = this.products[id - 1].cantidad;
    // this.cantPedidos = this.products[id - 1].cantidad_pedidos;
    const objeto = this.products.filter(y => y.producto_id === id)[0];
    console.log(objeto);
    x.patchValue({
      stock: parseInt(objeto.cantidad),// - parseInt(objeto.cantidad_pedidos),
      producto_id: objeto.producto_id,
      nombre_producto: objeto.codigo+'-'+objeto.nombre_producto,
      precio: objeto.precio_venta,
      precio2: objeto.costo_prom,
      costo: objeto.costo_prom,
      unidad: objeto.unidad,
      cantidad: 0
    });
  }

 

  get formData() {
    return <FormArray>this.form.get('credentials');
  }
  updateTotalUnitPrice(units: any) {
    // get our units group controll

    const control = <FormArray>this.form.controls['credentials'];
    // before recount total price need to be reset.
    this.totalSum = 0;

    for (const i in units) {
      const totalUnitPrice = units[i].cantidad * units[i].precio;
      // now format total price with angular currency pipe
      const totalUnitPriceFormatted = this.currencyPipe.transform(
        totalUnitPrice,
        'BOB',
        'symbol-narrow',
        '1.2-2'
      );
      // update total sum field on unit and do not emit event myFormValueChanges$ in this case on units
      control
        .at(+i)
        .get('totalUnitPrice')
        .setValue(totalUnitPrice.toFixed(2), {
          onlySelf: true,
          emitEvent: false
        });
      // update total price for all units
      this.totalSum += totalUnitPrice;
    }
  }

  save(model: any) {
  
    Swal.fire({
      title: 'Está seguro de modificar éste item?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, guardar!',
      cancelButtonText: 'No, Cancelar'
    }).then((result) => {
      if (result.value) {

        const data = {
          // cliente_id: this.selectedValue.cliente_id,
          // fecha_orden: this.fecha_orden,
          proforma_id: this.id,
          fecha_vencimiento: this.fecha_entrega,
          user_id: this.userid,
          productos: this.form.get('credentials').value,
          tipo_pago: this.form.get('pago').value
        };
    
        this.isLoading = true;
        this.proformaService
          .editarPedido(data)
          .pipe(
            finalize(() => {
              this.form.markAsPristine();
              this.isLoading = false;
            })
          )
          .subscribe(
            data1 => {
              Swal.fire(
                'Guardado!',
                'Su registro fue guardado con éxito.',
                'success'
              )
              // this.form.reset();
            //  this.router.navigate(['/dashboard/order-list']);
            },
            error1 => {
              Swal.fire(error1.error);
            }
          );
       
      // For more information about handling dismissals please visit
      // https://sweetalert2.github.io/#handling-dismissals
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        
      }
    })
 
  }

  entregarPedido() {
    Swal.fire({
      title: 'Está seguro de despachar éste pedido?',
      text:'Si realizó cambios en el pedido debe precionar modificar pedido antes de despachar ',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, guardar!',
      cancelButtonText: 'No, Cancelar'
    }).then((result) => {
      if (result.value) {
        const data = {
          // cliente_id: this.selectedValue.cliente_id,
          // fecha_orden: this.fecha_orden,
          orden_id: this.id,
          fecha_entrega: this.fecha_entrega,
          user_id: this.userid,
          tipo_pago: this.selected,
          monto_inicial: this.monto,
          productos: this.form.get('credentials').value
        };
        this.isLoading = true;
        this.orderService
          .despacharPedido(this.id)
          .pipe(
            finalize(() => {
              this.form.markAsPristine();
              this.isLoading = false;
            })
          )
          .subscribe(
            data1 => {
              Swal.fire(data1);
              // this.form.reset();
              this.router.navigate(['/dashboard/order-list']);
            },
            error1 => {
              Swal.fire('Usded No puede Despachar revise las cantidades de Stock.');
            }
          );
       
       
      // For more information about handling dismissals please visit
      // https://sweetalert2.github.io/#handling-dismissals
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        
      }
    })
  }
  realizarVenta() {
    Swal.fire({
      title: 'Está seguro de hacer la venta?',
      text:'Si realizó cambios en el pedido debe precionar modificar pedido antes de despachar ',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, guardar!',
      cancelButtonText: 'No, Cancelar'
    }).then((result) => {
      if (result.value) {
       
        const data = {
          // cliente_id: this.selectedValue.cliente_id,
          // fecha_orden: this.fecha_orden,
          orden_id: this.id,
          fecha_entrega: this.fecha_entrega,
          user_id: this.userid,
          tipo_pago: this.selected,
          monto_inicial: this.monto,
          productos: this.form.get('credentials').value
        };
        this.isLoading = true;
        this.orderService
          .realizarVenta(data)
          .pipe(
            finalize(() => {
              this.form.markAsPristine();
              this.isLoading = false;
            })
          )
          .subscribe(
            data1 => {
              Swal.fire(data1);
              // this.form.reset();
              this.router.navigate(['/dashboard/order-list']);
            },
            error1 => {
              Swal.fire(error1.error);
            }
          );
       
      // For more information about handling dismissals please visit
      // https://sweetalert2.github.io/#handling-dismissals
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        
      }
    })
  }

}
